export function Chat(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 5.59999C16.5523 5.59999 17 6.04771 17 6.59999C17 7.15228 16.5523 7.59999 16 7.59999H5.99997C5.44769 7.59999 4.99997 7.15228 4.99997 6.59999C4.99997 6.04771 5.44769 5.59999 5.99997 5.59999H16Z"
          fill="currentColor"
        />
        <path
          d="M16 10.6C16 10.0477 15.5523 9.59999 15 9.59999H6.99997C6.44769 9.59999 5.99997 10.0477 5.99997 10.6C5.99997 11.1523 6.44769 11.6 6.99997 11.6H15C15.5523 11.6 16 11.1523 16 10.6Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.20663 0.399994H17.7933C20.1129 0.399994 21.9933 2.2804 21.9933 4.59999C21.9933 4.6932 21.9902 4.78638 21.984 4.87937L21.3304 14.6842C21.2135 16.4376 19.7572 17.8 18 17.8H17.2V18.853C17.2 20.0152 16.2988 20.9669 15.1571 21.0475L15 21.053C14.4567 21.053 13.9326 20.852 13.5287 20.4887L10.54 17.8H4.80663C2.66458 17.8 0.877914 16.1911 0.634618 14.0847L0.615932 13.8794L0.0159316 4.87937C-0.138366 2.56492 1.61279 0.563593 3.92725 0.409296C4.02025 0.403096 4.11343 0.399994 4.20663 0.399994ZM17.7933 2.79999L4.14673 2.80099L4.08689 2.80398C3.09498 2.87011 2.34449 3.72782 2.41062 4.71973L3.01062 13.7197C3.07365 14.6653 3.85899 15.4 4.80663 15.4H10.6164C11.1597 15.4 11.6838 15.601 12.0877 15.9644L14.8 18.404V17.6C14.8 16.4378 15.7012 15.4861 16.8429 15.4055L17 15.4H18C18.4937 15.4 18.9028 15.0172 18.9357 14.5246L19.5893 4.71973L19.5933 4.59999C19.5933 3.60588 18.7874 2.79999 17.7933 2.79999Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
